import { Design } from '../types';
import { useSubject } from './use-subject';

/** Get the latest version of the @see Design that is loaded in the application. */
export function useLatestDesign(): Design | null {
  const appManager = window.apm;
  return useSubject(
    appManager.latestSerializedSubject,
    appManager.latestSerialized
  );
}
